import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const STORAGE_KEY = "dr_cookie_consent";

export const CookieConsent = () => {
  const { t } = useLanguage();
  const cc = t.cookieConsent;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] rounded-2xl border border-white/10 bg-[#111112]/95 backdrop-blur-xl shadow-[0_20px_50px_-15px_rgba(0,0,0,0.6)] p-4 flex items-start gap-3 animate-in fade-in slide-in-from-bottom-4 duration-500"
    >
      <div className="w-9 h-9 rounded-full bg-white/5 flex items-center justify-center shrink-0">
        <Cookie className="w-4 h-4 text-neutral-300" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-neutral-300 text-xs leading-relaxed mb-3">{cc.message}</p>
        <button
          onClick={handleAccept}
          data-testid="cookie-consent-accept-button"
          className="h-9 px-5 rounded-full bg-white text-black text-xs font-bold hover:bg-neutral-200 transition-colors duration-300"
        >
          {cc.acceptButton}
        </button>
      </div>
    </div>
  );
};
